import { useGetUserInfoQuery } from '@/utils/slices/accountSlice'
import { useState } from 'react'
export default function useMigratedTips() {
  const { data: userInfo } = useGetUserInfoQuery()
  const [hasOpened, setHasOpened] = useState(false)
  return {
    isMigrated: userInfo?.isMigrated,
    hasOpened,
    setHasOpened,
  }
}
